import { useContext } from "react";

import { LegalEntityType } from "@/codegen/openapi2";
import { OUIHELP_LEGAL_ENTITY_UUID } from "@/components/known-legal-entity-uuids";
import { useGetLegalEntityLegalEntitiesGet } from "@/services/2/react-query/hooks";

import { LegalEntityContext } from "../legal-entity-context";
import { MultiSelectDropdown } from "../multiselect-dropdown";

type MultiLegalEntitySelectorProps = {
  entities: string[];
  onChange: (entities?: string[]) => void;
};
export const MultiLegalEntitySelector = ({ entities, onChange }: MultiLegalEntitySelectorProps) => {
  const legalEntityContext = useContext(LegalEntityContext);
  // Filter legal entities based on the context or selected entities
  const { data: legalEntities } = useGetLegalEntityLegalEntitiesGet({}, [], {
    staleTime: 12 * 60 * 60 * 1000, // 12 hours
  });
  const filterLegalEntities = (allLegalEntities: LegalEntityType[]) => {
    if (!legalEntityContext) return allLegalEntities;

    if (legalEntityContext === OUIHELP_LEGAL_ENTITY_UUID) {
      return allLegalEntities?.filter(entity => entity.uuid === OUIHELP_LEGAL_ENTITY_UUID);
    }

    return allLegalEntities?.filter(entity => entity.uuid !== OUIHELP_LEGAL_ENTITY_UUID);
  };
  const filteredLegalEntities = !legalEntities ? [] : filterLegalEntities(legalEntities);

  return (
    <MultiSelectDropdown
      name="entities"
      label="Entité"
      pluralLabel="Entités"
      options={filteredLegalEntities.map(entity => ({
        value: entity.uuid,
        label: entity.name,
      }))}
      values={entities}
      onChangeValues={onChange}
    />
  );
};
